import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "sceneList__content" }
const _hoisted_2 = { class: "fl-left" }
const _hoisted_3 = { class: "fl-right" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "fl-row" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", null, "确定要收回该礼品卡？", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "已兑换的礼品卡将无法收回", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "text-error"
}, "收回礼品卡", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_app_table = _resolveComponent("app-table")!
  const _component_detail_modal = _resolveComponent("detail-modal")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, {
    class: "utils__pageContainer sceneList",
    title: "礼品卡管理"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_form, {
          class: "fl-clean sceneList__filterForm",
          form: _ctx.filterParams,
          layout: 'inline'
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_a_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, {
                    class: "ant-btn ant-btn-primary",
                    to: { name: 'gift_card.create' }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 开礼品卡 ")
                    ]),
                    _: 1
                  }, 8, ["to"]),
                  _createVNode(_component_router_link, {
                    class: "ant-btn ant-btn-primary",
                    to: { name: 'gift_card.batch' }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 批次列表 ")
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_a_form_item, { label: "油卡编号" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.filterParams.cardNo,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterParams.cardNo) = $event)),
                    "allow-clear": ""
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "开卡批次" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.filterParams.batchNumber,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filterParams.batchNumber) = $event)),
                    "allow-clear": ""
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "油卡状态" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    value: _ctx.filterParams.cardStatus,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filterParams.cardStatus) = $event)),
                    style: {"width":"170px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select_option, { value: "" }, {
                        default: _withCtx(() => [
                          _createTextVNode("所有")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: "1" }, {
                        default: _withCtx(() => [
                          _createTextVNode("未送出")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: "2" }, {
                        default: _withCtx(() => [
                          _createTextVNode("已送出")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: "3" }, {
                        default: _withCtx(() => [
                          _createTextVNode("已领取")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: "4" }, {
                        default: _withCtx(() => [
                          _createTextVNode("已作废")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "开卡时间" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_range_picker, {
                    value: _ctx.filterParams.issueTimeRange,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filterParams.issueTimeRange) = $event)),
                    style: {"width":"220px"},
                    format: "YYYY-MM-DD",
                    placeholder: ['起始时间', '结束时间']
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    ghost: "",
                    onClick: _ctx.onRefreshTable
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("查询")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["form"]),
        _createVNode(_component_app_table, {
          ref: "tableRef",
          size: "default",
          "row-key": "id",
          columns: _ctx.tableColumns,
          data: _ctx.loadTableData,
          alert: _ctx.tableOptions.alert,
          "row-selection": _ctx.tableOptions.rowSelection,
          "show-pagination": true
        }, {
          "view-qrcode": _withCtx(({ record }) => [
            _createElementVNode("a", {
              href: "#",
              onClick: ($event: any) => (_ctx.onViewItem(record))
            }, "查看", 8, _hoisted_4)
          ]),
          action: _withCtx(({ record }) => [
            _createElementVNode("span", _hoisted_5, [
              ([3, 4].indexOf(record.cardStatus) === -1)
                ? (_openBlock(), _createBlock(_component_a_popconfirm, {
                    key: 0,
                    placement: "top",
                    onConfirm: ($event: any) => (_ctx.onRecycle(record))
                  }, {
                    title: _withCtx(() => [
                      _hoisted_6,
                      _hoisted_7
                    ]),
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 2
                  }, 1032, ["onConfirm"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["columns", "data", "alert", "row-selection"])
      ]),
      _createVNode(_component_detail_modal, { ref: "detailModal" }, null, 512)
    ]),
    _: 1
  }))
}